import { Component, OnInit } from '@angular/core';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {
  public bg: any;

  constructor(
    private paramSv: ParamServicesService
  ) { }

  async ngOnInit() {
    const image: any = await this.paramSv.getImages('8');
    if(image.length){
      this.bg = image[0].images[0].file;
    }
  }

}
